"use client";

import React from "react";

/**
 * Renders text with clickable #hashtag tokens.
 * Clicking a hashtag navigates to `/hashtag/<tag>`.
 */
export function renderWithHashtags(
  text: string,
  onHashtagClick: (tag: string) => void,
): React.ReactNode {
  if (!text) return text;
  const parts = text.split(/(#[a-zA-Z][a-zA-Z0-9_]*)/g);
  return parts.map((part, i) => {
    if (/^#[a-zA-Z][a-zA-Z0-9_]*$/.test(part)) {
      return (
        <button
          key={i}
          type="button"
          onClick={(e) => {
            // preventDefault is required when this button is rendered inside
            // an outer <a> (e.g. sponsored ad cards) — otherwise the browser
            // still follows the anchor's href after the React handler runs.
            e.preventDefault();
            e.stopPropagation();
            onHashtagClick(part);
          }}
          className="text-blue-600 hover:underline font-medium"
        >
          {part}
        </button>
      );
    }
    return <span key={i}>{part}</span>;
  });
}
